import { render } from "./ExcludeDay-edit.vue?vue&type=template&id=155b535f"
import script from "./ExcludeDay-edit.vue?vue&type=script&lang=js"
export * from "./ExcludeDay-edit.vue?vue&type=script&lang=js"

import "./ExcludeDay-edit.vue?vue&type=style&index=0&id=155b535f&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__